import React, { Suspense, useState } from "react";
import { withRouter, Switch, useLocation } from "react-router-dom";
import * as staticConfigs from "../utilities/staticConfigs";
import PrivateRoute from "./privateRoute";
import { LoadingProvider } from "./loadingContext";
import Loading from "../components/commons/loading";
import "../components/mainLayoutComponent/style.css";
import { privateRoutes } from "./routerConfig";
import LoadingSkeleton from "../components/commons/loader/PageLoadIndicator";
import Layout from "../components/layout";

const ContentComponent = () => {

  const [showLoadingBar, setShowLoadingBar] = useState(false);
  let location = useLocation();

  if (
    location.pathname === "/" ||
    location.pathname === staticConfigs.LOGIN_ROUTE_SUPER ||
    location.pathname === staticConfigs.LOGIN_ROUTE_SUPER + "/" ||
    location.pathname === staticConfigs.ROUTE_VERIFY_EMAIL ||
    location.pathname === staticConfigs.ROUTE_RESET_PASSWORD ||
    location.pathname === staticConfigs.ROUTE_FORGOT_PASSWORD ||
    location.pathname === staticConfigs.ROUTE_FORCE_RESET_PASSWORD ||
    location.pathname === staticConfigs.ROUTE_FORGOT_SEND_MAIL ||
    location.pathname === staticConfigs.ROUTE_VIEW_RECEIPTS ||
    location.pathname === staticConfigs.ROUTE_SET_PASSWORD
  )
    return null;
  return (
    <LoadingProvider value={setShowLoadingBar}>
      <Layout>
        <Suspense fallback={<LoadingSkeleton />}>
          <Loading showLoadingBar={showLoadingBar} />
          <Switch>
            {privateRoutes.map((route) => (
              <PrivateRoute
                key={route.id}
                exact={route.exact}
                path={route.path}
                component={route.component}
              />
            ))}
          </Switch>
        </Suspense>
      </Layout>
    </LoadingProvider>
  );
};

export default withRouter(ContentComponent);
